window.badgeMethodFormatter = function(value, row) {
    if (value) {
        let method = value.toLowerCase();
        let methods = [
            'get',
            'post',
            'put',
            'delete',
            'patch',
            'head',
            'options'
        ];

        if (methods.includes(method)) {
            return '<span class="badge badge-method-' + method + '">' + value + '</span>';
        }
    }

    return '<span class="badge badge-method-default">' + value + '</span>';
};
